import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Button, Stack, Grid, Chip, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress,
} from '@mui/material';
import { AccountTree, Add, Delete, Edit, Circle } from '@mui/icons-material';
import { api } from '../config/api';

const Flujos: React.FC = () => {
  const navigate = useNavigate();
  const [flujos, setFlujos] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [dlg, setDlg] = useState(false);
  const [nombre, setNombre] = useState('');

  const cargar = () => {
    setLoading(true);
    api.get('/flujos').then((r) => setFlujos(r.data.flujos || [])).finally(() => setLoading(false));
  };
  useEffect(cargar, []);

  const crear = async () => {
    const { data } = await api.post('/flujos', { nombre: nombre || 'Mi flujo' });
    setDlg(false); setNombre('');
    navigate(`/app/flujos/${data.flujo.id}`);
  };

  const borrar = async (id: number) => {
    await api.delete(`/flujos/${id}`); cargar();
  };

  if (loading) return <Box sx={{ textAlign: 'center', mt: 6 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" spacing={1} sx={{ mb: 1 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <AccountTree color="primary" />
          <Typography variant="h4">Flujos del Agente</Typography>
        </Stack>
        <Button variant="contained" startIcon={<Add />} onClick={() => setDlg(true)}>Nuevo flujo</Button>
      </Stack>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Diseña visualmente cómo se comporta tu agente: arrastra bloques y conéctalos (si el cliente dice X → hacer Y).
      </Typography>

      <Grid container spacing={2}>
        {flujos.map((f) => (
          <Grid item xs={12} sm={6} md={4} key={f.id}>
            <Card sx={{ cursor: 'pointer' }} onClick={() => navigate(`/app/flujos/${f.id}`)}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">{f.nombre}</Typography>
                  <Chip size="small" icon={<Circle sx={{ fontSize: '10px !important' }} />} label={f.activo ? 'Activo' : 'Inactivo'} color={f.activo ? 'success' : 'default'} />
                </Stack>
                <Typography variant="body2" color="text.secondary" sx={{ minHeight: 36 }}>{f.descripcion || 'Sin descripción'}</Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 1 }} onClick={(e) => e.stopPropagation()}>
                  <Button size="small" startIcon={<Edit />} onClick={() => navigate(`/app/flujos/${f.id}`)}>Editar</Button>
                  <IconButton size="small" color="error" onClick={() => borrar(f.id)}><Delete fontSize="small" /></IconButton>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
        {flujos.length === 0 && (
          <Grid item xs={12}>
            <Card sx={{ textAlign: 'center', py: 6 }}>
              <AccountTree sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
              <Typography color="text.secondary">Aún no tienes flujos. Crea el primero para diseñar el comportamiento de tu agente.</Typography>
              <Button variant="contained" startIcon={<Add />} sx={{ mt: 2 }} onClick={() => setDlg(true)}>Crear mi primer flujo</Button>
            </Card>
          </Grid>
        )}
      </Grid>

      <Dialog open={dlg} onClose={() => setDlg(false)} fullWidth maxWidth="xs">
        <DialogTitle>Nuevo flujo</DialogTitle>
        <DialogContent>
          <TextField autoFocus fullWidth label="Nombre del flujo" sx={{ mt: 1 }} value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej: Flujo de ventas" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDlg(false)}>Cancelar</Button>
          <Button variant="contained" onClick={crear}>Crear y editar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Flujos;
